require('./bootstrap');
import Vue from 'vue';
import router from '@/router.js';
import paginator from '@/configs/paginator.js';
import titleMixin from '@/mixins/titleMixin.js';
import { i18n } from '@/plugins/i18n.js';
import '@/plugins/vee-validate.js';

/** Laravel AdminLTE vue components */
Vue.component('RegisterForm', require('./components/auth/RegisterForm.vue').default);
Vue.component('LoginForm', require('./components/auth/LoginForm.vue').default);
Vue.component('EmailResetPasswordForm', require('./components/auth/EmailResetPasswordForm.vue').default);
Vue.component('ResetPasswordForm', require('./components/auth/ResetPasswordForm.vue').default);
/** Laravel AdminLTE vue components */

/** External components */
Vue.component('VueSlideUpDown', require('vue-slide-up-down').default);
Vue.component('VueMultiselect', require('vue-multiselect').default);
Vue.component('Pagination', require('laravel-vue-pagination'));
Vue.component('DateRangePicker', require('vue2-daterange-picker').default);
/** External components */

/**
 * Mixins global
 **/
Vue.mixin(titleMixin);
Vue.mixin({
    methods: {
        number_format,
    },
});

/** Layers */
Vue.component('VueApp', require('./layouts/default.vue').default);

/** Internal components */
Vue.component('ArtisanCommands', require('./components/dev/ArtisanCommandsComponent.vue').default);
Vue.component('Alerts', require('./components/subcomponents/Alerts.vue').default);
Vue.component('MainModal', require('./components/modals/MainModalComponent.vue').default);
Vue.component('MainModalForm', require('./components/modals/MainModalFormComponent.vue').default);
Vue.component('ModalForm', require('./components/modals/ModalForm.vue').default);
Vue.component('Macros', require('./components/campaigns/MacrosComponent.vue').default);
Vue.component('ApiSourceNumbersFilesTable', require('./components/api-source-numbers/file/FileTable.vue').default);
Vue.component('ApiProviderCountryCosts', require('./components/apis/providers/ProviderCountryCostsComponent').default);
Vue.component('ApiProvidersComponent', require('./components/apis/providers/ProvidersTableComponent.vue').default);
Vue.component('BillingComponent', require('./components/billing/BillingComponent.vue').default);
Vue.component('ApiProvidersTopShow', require('./components/apis/providers/ProvidersShowTopComponent.vue').default);
Vue.component('ApiProvidersBottomShow', require('./components/apis/providers/ProvidersShowBottomComponent.vue').default);
Vue.component('MultiSelectComponent', require('./components/partials/MultiSelectComponent.vue').default);
Vue.component('SelectComponent', require('./components/partials/SelectComponent.vue').default);
Vue.component('CheckboxComponent', require('./components/partials/CheckboxComponent.vue').default);
Vue.component('UsersList', require('./components/users/ListComponent.vue').default);
Vue.component('PredefinedBodiesList', require('./components/predefined-bodies/bodies/BodiesListComponent').default);
Vue.component('PredefinedBodiesListTemplate', require('./components/predefined-bodies/bodies/BodiesListTable').default);
Vue.component('PredefinedBodiesCategoriesList', require('./components/predefined-bodies/categories/CategoriesListComponent').default);
Vue.component('PredefinedBodiesCategoriesTopShow', require('./components/predefined-bodies/categories/CategoriesShowTopComponent').default);
Vue.component(
    'PredefinedBodiesCategoriesBottomShow',
    require('./components/predefined-bodies/categories/CategoriesShowBottomComponent').default
);
Vue.component('ContactsListsListsPage', require('./components/contacts-lists/lists/ListComponent.vue').default);
Vue.component('ContactsListsLiveListsPage', require('./components/contacts-lists/live/ListComponent').default);
Vue.component('ContactsListsCategoriesPage', require('./components/contacts-lists/categories/CategoriesComponent').default);
Vue.component('ContactsListsCategoriesShow', require('./components/contacts-lists/categories/CategoriesShowComponent').default);
Vue.component('TagComponent', require('./components/contacts-lists/tags/TagsShowComponent.vue').default);
Vue.component('SdAccountsComponents', require('./components/short-domain-acconts/SDAccountsListComponent.vue').default);
Vue.component('SdAccountsShowComponents', require('./components/short-domain-acconts/SDAccountsShowComponent.vue').default);
Vue.component('DlrReport', require('./components/dlr-report/DLRReportComponent.vue').default);
Vue.component('ClickerReport', require('./components/clicker-report/ClickerReportComponent.vue').default);
Vue.component('NonClickerReport', require('./components/non-clicker-report/NonClickerReportComponent.vue').default);
Vue.component('ClickServerIps', require('./components/click-server-ips/ClickServerIpsComponent').default);
Vue.component('MultiSelectExtendedComponent', require('./components/partials/MultiSelectExtendedComponent.vue').default);
Vue.component('ImageConstructorComponent', require('./components/image-constructor/ImageConstructorComponent.vue').default);
Vue.component('FormSelect', require('./components/form/FormSelect.vue').default);
/** Internal components */

if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        data() {
            return {
                paginator,
            };
        },
        beforeCreate() {
            this.$nextTick(function () {
                $('[data-toggle="tooltip"]').tooltip();
                $('[data-toggle="popover"]').popover();
            });
        },
        i18n,
        router,
    });
}

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
    const dec = typeof dec_point === 'undefined' ? '.' : dec_point;
    let s = '';
    const toFixedFix = function (n, prec) {
        const k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
    };

    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
